// Hỏi máy chủ xem tính năng TÌM ĐỊA CHỈ có bật không (theo từng nước).
// Chưa khai khoá nhà cung cấp thì phải ẨN HẲN ô tìm địa chỉ, không hiện rồi báo lỗi khi gõ.
// Hỏi 1 lần cho mỗi nước rồi nhớ lại (nhiều ô địa chỉ trên cùng màn chỉ tốn 1 lượt gọi).
import { useEffect, useState } from 'react';
import AntAPI from '../../../utils/AntAPI';

var _cache = {}; // nước -> { enabled, provider, supports_proximity }
var _inflight = {}; // nước -> Promise

var unwrap = function (r) {
    return (r && r.data ? r.data : r) || {};
};

export function getAddressSearchCapability(country) {
    var cc = String(country || 'VN').toUpperCase();
    if (_cache[cc]) return Promise.resolve(_cache[cc]);
    if (_inflight[cc]) return _inflight[cc];

    var API = new AntAPI('sys', 'SysAddress');
    _inflight[cc] = API.postActionWithData('getSearchCapability', { country: cc })
        .then(function (res) {
            var d = unwrap(res);
            _cache[cc] = {
                enabled: !!d.enabled,
                provider: d.provider || null,
                supports_proximity: !!d.supports_proximity
            };
            delete _inflight[cc];
            return _cache[cc];
        })
        .catch(function () {
            // Hỏi không được thì coi như TẮT (ẩn ô tìm) — an toàn hơn hiện ra rồi lỗi.
            delete _inflight[cc];
            var off = { enabled: false, provider: null, supports_proximity: false };
            _cache[cc] = off;
            return off;
        });
    return _inflight[cc];
}

export function clearAddressSearchCapability() {
    _cache = {};
    _inflight = {};
}

/**
 * Trả về: null = đang hỏi (chưa biết) · true = bật · false = tắt.
 * Màn hình dùng để ẩn cả thẻ "Tìm nhanh" chứ không chỉ ẩn ô nhập.
 */
export function useAddressSearchEnabled(country) {
    var [state, setState] = useState(null);
    useEffect(
        function () {
            var alive = true;
            getAddressSearchCapability(country).then(function (c) {
                if (alive) setState(!!c.enabled);
            });
            return function () {
                alive = false;
            };
        },
        [country]
    );
    return state;
}

export default { getAddressSearchCapability, useAddressSearchEnabled, clearAddressSearchCapability };
